import type { QueryClient } from '@tanstack/react-query';

/**
 * Lo que hace cada app cuando el API avisa `session:changed` (cambió el staff
 * del usuario): vuelve a pedir la sesión y, si cambió, invalida lo que
 * dependía de ella. Lo comparten folder, tournament-app y la super-app.
 *
 * Invalida sólo las queries que ya existían al llegar el aviso. Las que se
 * crean después las monta la sesión nueva (el panel de organizador que
 * aparece al pasar a serlo) y ya nacen con datos frescos: invalidarlas era
 * pedirlas dos veces.
 *
 * Devuelve si la sesión cambió.
 */
export async function handleSessionChanged(
  queryClient: QueryClient,
  refreshSession: () => Promise<boolean>
): Promise<boolean> {
  const before = new Set(
    queryClient
      .getQueryCache()
      .getAll()
      .map((query) => query.queryHash)
  );

  if (!(await refreshSession())) return false;

  await queryClient.invalidateQueries({
    predicate: (query) => before.has(query.queryHash),
  });
  return true;
}
